import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-whatsapp-report',
    templateUrl: './whatsapp-report.component.html',
    styleUrls: ['./whatsapp-report.component.scss'],
})
export class WhatsappReportComponent implements OnInit {
    searchData!: FormGroup;
    stateList: any[] = [];
    districtList: any[] = [];
    isLoading = false;
    breadCrumbItems: any[] = [];
    reportData: any = null;

    constructor(
        private fb: FormBuilder,
        private generalService: GeneralService,
        private http: HttpClient
    ) { }

    ngOnInit() {
        this.searchData = this.fb.group({
            state: new FormControl(7),
            district: new FormControl([]),
            selectedDate: new FormControl(new Date()),
        });

        this.loadStates();
        this.loadDistricts(7);
    }

    loadStates() {
        this.generalService.getState().subscribe(
            (res: any) => {
                if (res && res.status === 200 && Array.isArray(res.data)) {
                    this.stateList = res.data;
                } else {
                    console.warn('Invalid state response:', res);
                }
            },
            (err) => {
                console.error('Error fetching states:', err);
                Swal.fire('Error', 'Failed to load states', 'error');
            }
        );
    }

    loadDistricts(id?: number) {
        this.generalService.getDistrict(id).subscribe(
            (res: any) => {
                if (res && res.status === 200 && Array.isArray(res.data)) {
                    this.districtList = res.data;
                } else {
                    console.warn('Invalid district response:', res);
                }
            },
            (err) => {
                console.error('Error fetching districts:', err);
                Swal.fire('Error', 'Failed to load districts', 'error');
            }
        );
    }

    onStateChange(event: any) {
        const stateId = event.value;
        console.log('Selected State ID:', stateId);

        this.searchData.get('district').reset();
        if (stateId) {
            this.loadDistricts(stateId);
        }
    }

    isAllSelected() {
        const selected = this.searchData.get('district').value || [];
        var result =selected.length-1 === this.districtList.length;
        return result;
    }

    

    toggleSelectAll() {
        const control = this.searchData.get('district');

        if (this.isAllSelected()) {
            control.setValue([]); // UNSELECT ALL
        } else {
            control.setValue(this.districtList.map(d => d.Name)); // SELECT ALL
        }
    }


    onSubmit() {
        if (!this.searchData.valid) {
            Swal.fire(
                'Invalid Input',
                'Please fill all required fields',
                'warning'
            );
            return;
        }

        const { state, district, selectedDate } = this.searchData.value;
        const selected = new Date(selectedDate);

        const istDate = new Date(selected.getTime() + 5.5 * 60 * 60 * 1000);

        const formattedDate = istDate.toISOString().slice(0, 10);

        this.isLoading = true;
        this.reportData = null;

        this.generalService
            .getWhatsappReport(formattedDate, state, district)
            .subscribe({
                next: (res: any) => {
                    this.reportData = res;
                    this.isLoading = false;
                },
                error: (err) => {
                    console.error('Error fetching WhatsApp report:', err);
                    Swal.fire('Error', 'Failed to fetch report', 'error');
                    this.isLoading = false;
                },
            });
    }

    resetForm() {
        this.searchData.reset({
            state: 7,
            district: [],
            selectedDate: new Date(),
        });
        this.loadDistricts(7);
        this.reportData = null;
    }
}
